/**
 * @generated SignedSource<<0e1ad2d5389fd1a44a3c0fa95125a714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TableBody_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RenderChildRowsComp_rules" | "Rows_rules">;
  readonly " $fragmentType": "TableBody_rules";
};
export type TableBody_rules$key = {
  readonly " $data"?: TableBody_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"TableBody_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "TableBody_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Rows_rules"
    },
    {
      "kind": "FragmentSpread",
      "name": "RenderChildRowsComp_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "f8bf89a7757ce2f426b62f58f32de215";

export default node;
